export { DeleteProductModal } from './DeleteProductModal';
